import React from 'react';
import Header from 'modules/header/farm/main';
import EditProfile from 'modules/profile/editProfile';

const Profile = () => {
  return (
    <>
      <Header title="پروفایل" />
      <EditProfile />
    </>
  );
};

export default Profile;
